import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

//DSS Documentation on SocoFormService - http://tiny.sc/cgsocoformservice
import { SocoFormService } from '@soco/forms';
//DSS Documentation on SocoHttpService - http://tiny.sc/cgSocoHttpService
import { SocoHttpService } from '@soco/http';
//DSS Documentation on SocoModalService - http://tiny.sc/cgsocomodalservice
import { SocoModalService } from '@soco/modal';

import { SampleService } from '../sample.service';
import { Sample } from '../sample';

@Component({
    selector: 'sample-add',
    templateUrl: 'sample-add.component.html'
})
export class SampleAddComponent implements OnInit {
    alertId: string = 'alert-sample-add';
    modalId: string = 'modal-sample-add';
    form: FormGroup;
    @Output() sampleAddClosed = new EventEmitter();

    //DSS Documentation on SocoFormService - http://tiny.sc/cgsocoformservice
    //DSS Documentation on SocoModalService - http://tiny.sc/cgsocomodalservice
    constructor(private sampleService: SampleService, private socoFormService: SocoFormService, private http: SocoHttpService, private socoModalService: SocoModalService, private formBuilder: FormBuilder) { }

    ngOnInit(): void {
        this.form = this.formBuilder.group(new Sample());
    }

    //=============================================================================================================
    //EVENT HANDLERS
    //=============================================================================================================
    formSubmitted(sample: Sample): void {
        this.add(sample);
    }

    show(): void {
        //re-initialize a notification to clear any previous changes
        this.form = this.formBuilder.group(new Sample());

        //show the modal
        //DSS Documentation on SocoModalService - http://tiny.sc/cgsocomodalservice
        this.socoModalService.show({
            id: this.modalId,
            onClose: () => {
                this.sampleAddClosed.emit();
            }
        });
    }

    //=============================================================================================================
    //WEB METHODS
    //=============================================================================================================
    private add(sample: Sample): void {
        this.sampleService.add(sample, this.alertId).subscribe(result => {
            //DSS Documentation on SocoModalService - http://tiny.sc/cgsocomodalservice
            this.socoModalService.hide(); //hide the modal which will trigger the event emitter so the parent will refresh
        }, result => {
            //DSS Documentation on SocoFormService - http://tiny.sc/cgsocoformservice
            //DSS Documentation on Validation - http://tiny.sc/cgvalidation
            if (this.http.isInvalidResult(result)) {
                this.form = this.socoFormService.invalidateForm(this.form, result);
            }
        });
    }
}
